import "./Contact.module.css";
import EnTeteDeNavigation from "@/reusable_sections/Header";
import ClinicalGrounding from "./sections/ClinicalGrounding";
import ContactLocation from "./sections/ContactLocation";
import ContactTampaTileSpecialistsFreeEstimateInTampaFl from "./sections/ContactTampaTileSpecialistsFreeEstimateInTampaFl";
import ContactInfo from "./sections/ContactInfo";
import ReadyToTransformProject from "@/pages/PrivacyPolicy/sections/ReadyToTransformProject";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <EnTeteDeNavigation />
      <ClinicalGrounding />
      <ContactLocation />
      <ContactTampaTileSpecialistsFreeEstimateInTampaFl />
      <ContactInfo />
      <ReadyToTransformProject />
      <Footer />
    </div>;
}